import { Typography, Button, IconButton, Link } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import useSession from "../../hooks/useSession";
import hhIcon from "../../assets/icons/hh-icon.svg";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/actions/userActions";
import { useIntercom } from "react-use-intercom";
import { LEGAL_LINKS } from "../../utils/constants";

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundColor: "#022752",
    display: "flex",
    flexDirection: "column",
  },
  topbar: {
    display: "flex",
    flexDirection: "row",
    width: "95%",
    justifyContent: "space-between",
    alignSelf: "center",
  },
  text: {
    width: "90%",
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    marginTop: "30px",
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    bottom: 0,
    right: 0,
    left: 0,
    width: "90%",
    alignSelf: "center",
    marginTop: "3rem",
  },
}));

const MobileMenu = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { authenticated } = useSession();
  const { boot, show } = useIntercom();
  const dispatch = useDispatch();

  const handleOpenContactSupport = () => {
    boot();
    show();
  };

  return (
    <div className={classes.background}>
      <div className={classes.topbar}>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={() => navigate("/")}
        >
          <img alt="" src={hhIcon} width="33px" />
        </IconButton>
      </div>

      <div className={classes.text}>
        {(!authenticated && (
          <>
            <Typography variant="h1" textAlign="left" color="white">
              Services
            </Typography>
            <Typography variant="h1" color="white" textAlign="left" mt="10px">
              About
            </Typography>
            <Typography variant="h1" color="white" textAlign="left" mt="10px">
              Resources
            </Typography>
            <Link
              variant="h1"
              mt="10px"
              textAlign="left"
              sx={{ textDecoration: "none" }}
              href={`${process.env.REACT_APP_WEB_URL}/faq`}
            >
              <Typography variant="h1" color="white">
                FAQs
              </Typography>
            </Link>
            <Link
              mt="34px"
              sx={{ textDecoration: "none", alignSelf: "start" }}
              onClick={() => handleOpenContactSupport()}
            >
              <Typography variant="h9">Get Support</Typography>
            </Link>
            <Link
              href={`${process.env.REACT_APP_WEB_URL}/terms-of-service`}
              sx={{ textDecoration: "none", alignSelf: "start" }}
            >
              <Typography variant="h9">Terms of Use</Typography>
            </Link>
            <Link
              onClick={() => {
                window.open(LEGAL_LINKS.PRIVACY_POLICY);
              }}
              sx={{ textDecoration: "none", alignSelf: "start" }}
            >
              <Typography variant="h9">Privacy Policy</Typography>
            </Link>

            <div className={classes.buttons}>
              <Button
                variant="outlined"
                sx={{ borderColor: "#022752", color: "white" }}
                onClick={() => navigate("/login")}
              >
                Log in
              </Button>
              <Button
                sx={{ backgroundColor: "#022752", color: "white", mt: "12px" }}
                onClick={() => navigate("/sign-up")}
              >
                Sign up
              </Button>
            </div>
          </>
        )) || (
          <>
            <Typography
              variant="h1"
              textAlign="left"
              color="white"
              onClick={() => navigate("/my-projects")}
            >
              Projects
            </Typography>
            <Typography
              variant="h1"
              color="white"
              textAlign="left"
              mt="10px"
              onClick={() => navigate("/notifications")}
            >
              Notifications
            </Typography>
            <Typography
              variant="h1"
              color="white"
              textAlign="left"
              mt="10px"
              onClick={() => navigate("/messages")}
            >
              Messages
            </Typography>
            <Typography
              variant="h1"
              color="white"
              textAlign="left"
              mt="10px"
              onClick={() => navigate("/my-account")}
            >
              Account
            </Typography>
            <Link
              variant="h9"
              mt="34px"
              onClick={() => handleOpenContactSupport()}
            >
              <Typography variant="h9">Get Support</Typography>
            </Link>
            <Link
              onClick={() => {
                window.open(LEGAL_LINKS.TERMS_OF_USE);
              }}
              sx={{ textDecoration: "none", alignSelf: "start" }}
            >
              <Typography variant="h9">Terms of Use</Typography>
            </Link>
            <Link
              onClick={() => {
                window.open(LEGAL_LINKS.PRIVACY_POLICY);
              }}
              sx={{ textDecoration: "none", alignSelf: "start" }}
            >
              <Typography variant="h9">Privacy Policy</Typography>
            </Link>
            <div className={classes.buttons}>
              <Button
                sx={{ backgroundColor: "#43B12E", color: "white" }}
                onClick={() => navigate("/")}
              >
                Create a Project
              </Button>
              <Button
                sx={{ color: "white" }}
                onClick={() => dispatch(logout())}
              >
                Log Out
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
